module.exports = __webpack_public_path__ + "allegro_.png?5816ed88aa51460d1817a5f760928c00";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/allegro_.png
// module id = 949
// module chunks = 2